



































import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { IRepairEstimate } from "@/models/repair-estimate.entity";
import { RefTypeMap } from "@/store/modules/refs.store";
import { Component, Prop } from "vue-property-decorator";
import BaseRef from "./BaseRef.vue";
import { IRefDetail } from "./RefsList.vue";
import Tooltip from "./tooltip.vue";
import { formatCurrency } from "@/lib/utility/currency-helper";

@Component({
  components: { Tooltip },
  filters: { simpleDoubleDigitDate }
})
export default class RefsRepairEstimate extends BaseRef<IRepairEstimate> implements IRefDetail<IRepairEstimate> {
  readonly RefsTypeMap = RefTypeMap;
  readonly formatCurrency = formatCurrency;

  @Prop()
  item!: IRepairEstimate;

  @Prop({ default: false })
  small!: boolean;

  @Prop({ default: false })
  confirmable!: boolean;

  goToDetail() {
    this.item.goTo(this.$router).detail();
  }

  get hasOpenDetailListener() {
    return Boolean(this.$listeners && this.$listeners.openDetail);
  }

  get hasClickListener() {
    return Boolean(this.$listeners && this.$listeners.click);
  }
}
